import { common, authError } from '../../../modules/error';

export const getErrorMessageFromAuthErrorCode = (authErrorCode: string): string => {
  switch (authErrorCode) {
    case 'auth/too-many-requests':
      return authError.invalidEmail;
    case 'auth/invalid-email':
      return authError.invalidEmail;
    case 'auth/user-not-found':
    case 'auth/invalid-uid':
      return authError.userNotFound;
    case 'auth/invalid-credential':
      return authError.invalidCredential;
    case 'auth/network-request-failed':
      return authError.networkRequestFailed;
    default:
      return common;
  }
};
